var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('mynav1_en',{attrs:{"data":_vm.nvdata}}),_c('cthead',{attrs:{"data":_vm.headdata}}),_c('servicect',{attrs:{"data":_vm.pdctdata}}),_c('myfooter_en',{attrs:{"data":_vm.ftdata}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }